import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyNumberList,
  PolicySectionTitle,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ServiceEs = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "es";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          ES
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/service">EN</Link>
            </li>
            <li>
              <Link to="/policy/ja/service">JA</Link>
            </li>
            <li>
              <Link to="/policy/vi/service">VI</Link>
            </li>
            <li>
              <Link to="/policy/th/service">TH</Link>
            </li>
            <li>
              <Link to="/policy/id/service">ID</Link>
            </li>
            <li className="selected">
              <em>ES</em>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>Términos de Uso de pregnancy&amp;baby</PolicyTitle>

      <PolicyVersion>
        Fecha de entrada en vigor: [21 de septiembre de 2026]
        <br />
        Última actualización: [25 de agosto de 2026]
      </PolicyVersion>

      <PolicySectionTitle>
        Capítulo 1. Bienvenido/a a pregnancy&amp;baby
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong> ofrece diversos servicios diseñados
        para acompañar a las personas usuarias durante la preparación para el
        embarazo, los tratamientos de fertilidad, el embarazo, el parto, la
        recuperación posparto y el cuidado infantil. Estos servicios pueden
        incluir registros de salud y diarios, informes personalizados,
        contenidos informativos, funciones de comunidad y otras funcionalidades
        relacionadas.
      </PolicyText>
      <PolicyText>
        Los presentes Términos de Uso (“Términos”) regulan el uso de la
        aplicación móvil <strong>pregnancy&amp;baby</strong>, el sitio web y los
        servicios relacionados (conjuntamente, los “Servicios”) proporcionados
        por Connecti Co., Ltd. (la “Empresa”, “nosotros”, “nos” o “nuestro”).
      </PolicyText>
      <PolicyText>
        Le rogamos que lea atentamente estos Términos antes de utilizar los
        Servicios.
      </PolicyText>

      <PolicyArticleTitle>Artículo 1. Objeto y definiciones</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los presentes Términos establecen los derechos, obligaciones,
          responsabilidades, condiciones de uso y demás cuestiones relativas al
          uso de los Servicios entre la Empresa y las personas usuarias que
          acepten estos Términos y completen el registro de una cuenta
          (“Miembros”).
        </li>
        <li>
          A efectos de estos Términos:
          <PolicyHyphenList>
            <li>
              <strong>“Servicios”</strong> significa la aplicación móvil
              pregnancy&amp;baby, el sitio web y cualesquiera servicios
              relacionados proporcionados por la Empresa.
            </li>
            <li>
              <strong>“Miembro”</strong> significa una persona usuaria que
              acepta estos Términos y completa el registro para utilizar los
              Servicios.
            </li>
            <li>
              <strong>“Cuenta”</strong> significa la cuenta utilizada por un
              Miembro para acceder y utilizar los Servicios.
            </li>
            <li>
              <strong>“Información de la Cuenta”</strong> significa la
              información asociada a la Cuenta de un Miembro que puede
              visualizarse o gestionarse a través de los Servicios.
            </li>
            <li>
              <strong>“Contenido”</strong> significa textos, imágenes,
              fotografías, vídeos, datos, información, comentarios,
              publicaciones y otros materiales disponibles a través de los
              Servicios o enviados, cargados o publicados en ellos.
            </li>
            <li>
              <strong>“Servicios de Pago”</strong> significa contenidos
              digitales, funciones, informes u otros servicios proporcionados
              por la Empresa que pueden utilizarse mediante un{" "}
              <strong>pago único.</strong>
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 2. Vigencia y modificación de los Términos
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los presentes Términos entrarán en vigor cuando se pongan a
          disposición a través de los Servicios o por otro medio adecuado y el
          Miembro los acepte.
        </li>
        <li>
          La Empresa podrá modificar estos Términos en la medida permitida por
          la legislación aplicable.
        </li>
        <li>
          Cuando se modifiquen estos Términos, la Empresa informará, con
          carácter general, sobre los cambios y la fecha de entrada en vigor con
          al menos <strong>15 días de antelación</strong>.
        </li>
        <li>
          Si una modificación resulta materialmente desfavorable para los
          Miembros, la Empresa informará, con carácter general, con al menos{" "}
          <strong>30 días de antelación</strong> mediante correo electrónico,
          aviso dentro de la aplicación, notificación push u otro medio
          electrónico adecuado.
        </li>
        <li>
          Cuando lo permita la legislación aplicable, si la Empresa informa
          claramente de que la falta de oposición dentro de un plazo determinado
          podrá considerarse aceptación de los Términos modificados y el Miembro
          no manifiesta su oposición dentro de dicho plazo, podrá considerarse
          que ha aceptado los Términos modificados.
        </li>
        <li>
          Si un Miembro no acepta los Términos modificados, podrá poner fin a la
          relación contractual de uso de los Servicios mediante la eliminación
          de su Cuenta.
        </li>
        <li>
          Estos Términos se aplicarán, con carácter general, desde la fecha en
          que el Miembro los acepte hasta la terminación de la relación
          contractual de uso de los Servicios. Las disposiciones que, por su
          naturaleza, deban continuar vigentes después de la terminación podrán
          seguir siendo aplicables.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Artículo 3. Normas adicionales</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Las cuestiones no previstas expresamente en estos Términos se regirán
          por la legislación aplicable, las condiciones específicas de cada
          servicio y las políticas operativas, directrices y normas de la
          Empresa (“Políticas Operativas”).
        </li>
        <li>
          Cuando un servicio específico esté sujeto a condiciones adicionales,
          dichas condiciones adicionales serán aplicables a ese servicio.
        </li>
        <li>
          Si estos Términos entran en conflicto con una disposición imperativa
          de la legislación aplicable, prevalecerá dicha disposición legal.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>
        Capítulo 2. Registro y gestión de la Cuenta
      </PolicySectionTitle>
      <PolicyArticleTitle>Artículo 4. Registro</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Se considerará que una persona usuaria ha aceptado estos Términos
          cuando seleccione durante el proceso de registro un botón o casilla
          como “Aceptar”, “Accept”, “Continue” u otra opción equivalente.
        </li>
        <li>
          Para registrarse en los Servicios, la persona usuaria deberá facilitar
          la información requerida y completar el procedimiento de registro
          establecido por la Empresa.
        </li>
        <li>
          Los Miembros podrán crear o acceder a una Cuenta mediante los métodos
          compatibles con la Empresa, entre ellos:
          <PolicyHyphenList>
            <li>Correo electrónico</li>
            <li>Google</li>
            <li>Apple</li>
          </PolicyHyphenList>
        </li>
        <li>
          La Empresa podrá solicitar información o verificaciones adicionales
          cuando sean razonablemente necesarias para proporcionar una función
          concreta, proteger a los Miembros, cumplir la legislación aplicable o
          prevenir el uso indebido de los Servicios.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 5. Aceptación, suspensión y rechazo del registro
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          El registro se completará cuando la persona usuaria presente una
          solicitud de registro y la Empresa la acepte.
        </li>
        <li>
          La Empresa aceptará, con carácter general, las solicitudes de registro
          debidamente completadas. No obstante, podrá suspender, rechazar o
          cancelar un registro si:
          <PolicyHyphenList>
            <li>
              La persona solicitante utiliza sin autorización la identidad,
              dirección de correo electrónico, Cuenta u otra información de otra
              persona;
            </li>
            <li>
              La persona solicitante proporciona información falsa, incompleta o
              engañosa;
            </li>
            <li>
              La Empresa no dispone de capacidad técnica razonable para prestar
              los Servicios;
            </li>
            <li>
              Existen problemas técnicos u operativos que impiden la prestación
              de los Servicios;
            </li>
            <li>
              Una persona cuyo uso de los Servicios haya sido previamente
              suspendido o restringido intenta eludir dicha restricción creando
              otra Cuenta;
            </li>
            <li>
              El registro infringiría la legislación aplicable, estos Términos o
              las Políticas Operativas; o
            </li>
            <li>
              La Empresa determina razonablemente que el registro no puede
              aceptarse por motivos legítimos de carácter técnico, de seguridad,
              operativo o jurídico.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Si la Empresa descubre posteriormente que un Miembro se registró
          infringiendo este Artículo, podrá restringir el uso de los Servicios,
          suspender la Cuenta o eliminarla, según corresponda.
        </li>
      </PolicyNumberList>
      <PolicyArticleTitle>Artículo 6. Gestión de la Cuenta</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los Miembros son responsables de gestionar adecuadamente sus Cuentas y
          de impedir su uso no autorizado por terceros.
        </li>
        <li>
          Si un Miembro tiene conocimiento de un acceso o uso no autorizado de
          su Cuenta, deberá adoptar sin demora medidas razonables para
          protegerla y comunicarlo a la Empresa.
        </li>
        <li>
          Los Miembros podrán consultar o modificar determinada Información de
          la Cuenta a través de los Servicios. Ciertos datos pueden no ser
          modificables directamente cuando sea necesario limitar dicha
          modificación por razones de seguridad de la Cuenta, identificación o
          motivos técnicos.
        </li>
        <li>
          Si un Miembro necesita actualizar información que no puede modificar
          directamente, podrá ponerse en contacto con Atención al Cliente.
        </li>
        <li>
          Cuando un Miembro utilice el inicio de sesión mediante Google, Apple,
          la autenticación se realizará mediante un token u otro mecanismo de
          autenticación proporcionado por el correspondiente servicio de
          terceros. La Empresa no ofrece recuperación de contraseñas para las
          credenciales de acceso gestionadas por dichos proveedores externos.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>Capítulo 3. Uso de los Servicios</PolicySectionTitle>
      <PolicyArticleTitle>
        Artículo 7. Prestación de los Servicios
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los Miembros podrán utilizar los Servicios una vez completado el
          registro y los procedimientos necesarios para la función
          correspondiente.
        </li>
        <li>
          Los Servicios pueden incluir, entre otros:
          <PolicyHyphenList>
            <li>
              Preparación para el embarazo y seguimiento del ciclo menstrual
            </li>
            <li>Registro y análisis de pruebas de ovulación y embarazo</li>
            <li>Registro de tratamientos de fertilidad</li>
            <li>Diario del embarazo e informes relacionados con el embarazo</li>
            <li>Informes sobre el crecimiento fetal</li>
            <li>Control del peso durante el embarazo y el posparto</li>
            <li>
              Funciones relacionadas con el crecimiento y desarrollo infantil
            </li>
            <li>Registro de salud y cuidado infantil</li>
            <li>Guías y contenidos informativos</li>
            <li>Funciones de comunidad</li>
            <li>Otras funciones proporcionadas por la Empresa</li>
          </PolicyHyphenList>
        </li>
        <li>
          Determinadas funciones pueden requerir:
          <PolicyHyphenList>
            <li>Información adicional;</li>
            <li>
              Consentimientos separados, incluido el consentimiento relativo al
              tratamiento de datos de salud u otros Datos Personales sensibles;
            </li>
            <li>Requisitos de edad o elegibilidad;</li>
            <li>Condiciones o políticas adicionales; o</li>
            <li>
              Otros requisitos razonables necesarios para proporcionar la
              función correspondiente.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          La Empresa podrá ofrecer actualizaciones de software para mejorar o
          modificar los Servicios o para añadir o eliminar funciones. Se
          recomienda a los Miembros utilizar la versión más reciente disponible
          de la aplicación cuando sea posible.
        </li>
        <li>
          La Empresa podrá mostrar dentro de los Servicios avisos relacionados
          con el servicio, mensajes administrativos, contenidos informativos u
          otras comunicaciones.
        </li>
        <li>
          Los correos electrónicos, notificaciones push u otras comunicaciones
          similares con fines comerciales o promocionales se enviarán de
          conformidad con el consentimiento del Miembro y la legislación
          aplicable.
        </li>
        <li>
          Si un Miembro detecta un error del sistema u otro problema durante el
          uso de los Servicios, podrá ponerse en contacto con Atención al
          Cliente en:
          <br />
          <a href="mailto:after10month@connect-i.co.kr">
            after10month@connect-i.co.kr
          </a>
        </li>
        <li>
          Los Miembros serán responsables de los gastos de datos o
          telecomunicaciones que puedan aplicar sus proveedores de internet u
          operadores móviles en relación con el uso de los Servicios.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 8. Suspensión, modificación y finalización de los Servicios
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          La Empresa realizará esfuerzos razonables para proporcionar los
          Servicios de forma continua y fiable.
        </li>
        <li>
          Salvo que la legislación disponga otra cosa, la totalidad o parte de
          los Servicios podrá limitarse temporalmente, suspenderse, modificarse
          o finalizarse en circunstancias como:
          <PolicyHyphenList>
            <li>
              Mantenimiento, inspección, reparación o sustitución de sistemas o
              equipos;
            </li>
            <li>
              Cortes de electricidad, fallos de equipos, congestión de red u
              otros problemas técnicos;
            </li>
            <li>
              Finalización o modificación de acuerdos con proveedores de
              servicios externos;
            </li>
            <li>Órdenes gubernamentales, regulaciones o exigencias legales;</li>
            <li>
              Cambios en políticas operativas, de seguridad o de servicio;
            </li>
            <li>
              Catástrofes naturales, emergencias, guerras, disturbios civiles u
              otros acontecimientos de fuerza mayor; o
            </li>
            <li>
              Otras circunstancias que hagan inviable la continuidad de los
              Servicios.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Cuando sea razonablemente posible, la Empresa notificará previamente
          cualquier suspensión o finalización material mediante los métodos
          indicados en el Artículo 21.
        </li>
        <li>
          Es posible que no pueda realizarse una notificación previa cuando la
          suspensión se deba a circunstancias inesperadas o fuera del control
          razonable de la Empresa, como fallos de servidor, interrupciones del
          sistema, incidentes de seguridad o fallos de sistemas de terceros.
        </li>
        <li>
          En dichas circunstancias, la Empresa realizará esfuerzos razonables
          para restablecer los Servicios tan pronto como sea posible.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 9. Gestión del Contenido de los Miembros
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Si el Contenido publicado por un Miembro infringe derechos de autor,
          privacidad, propiedad intelectual u otros derechos, el titular de
          dichos derechos podrá solicitar las medidas oportunas conforme a la
          legislación aplicable.
        </li>
        <li>
          La Empresa podrá restringir el acceso, eliminar temporalmente o
          eliminar permanentemente Contenido cuando determine razonablemente que
          dicho Contenido:
          <PolicyHyphenList>
            <li>Infringe la legislación aplicable;</li>
            <li>Vulnera los derechos de otra persona;</li>
            <li>Infringe estos Términos o las Políticas Operativas;</li>
            <li>
              Amenaza la seguridad o el correcto funcionamiento de los
              Servicios; o
            </li>
            <li>
              Requiere una actuación para proteger a los Miembros o a terceros.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Los procedimientos relativos a denuncias, retirada de Contenido y
          otras medidas relacionadas podrán detallarse adicionalmente en las
          Políticas Operativas.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 10. Titularidad y uso del Contenido
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los Miembros podrán subir fotografías, textos, información, vídeos,
          comentarios, sugerencias y otros Contenidos a los Servicios.
        </li>
        <li>
          Los Miembros conservarán los derechos de propiedad intelectual que les
          correspondan sobre el Contenido que publiquen.
        </li>
        <li>
          Al publicar Contenido en áreas de los Servicios destinadas a
          compartirlo con otras personas, el Miembro concede a la Empresa una
          licencia no exclusiva para alojar, almacenar, reproducir, mostrar, dar
          formato y modificar técnicamente dicho Contenido en la medida
          razonablemente necesaria para operar, mostrar, proporcionar y mejorar
          la función correspondiente.
        </li>
        <li>
          El Contenido de los Miembros podrá aparecer en resultados de búsqueda,
          feeds, áreas de contenido personalizado u otras ubicaciones dentro de
          los Servicios, cuando resulte adecuado a la función en la que se
          publicó.
        </li>
        <li>
          La Empresa podrá rechazar, restringir o eliminar Contenido sin previo
          aviso cuando determine razonablemente que dicho Contenido:
          <PolicyHyphenList>
            <li>Es ilegal;</li>
            <li>Es obsceno o implica explotación sexual;</li>
            <li>Promueve el odio, la discriminación ilegal o la violencia;</li>
            <li>Constituye spam o publicidad no autorizada;</li>
            <li>Suplanta la identidad de otra persona;</li>
            <li>Infringe derechos de terceros;</li>
            <li>Es fraudulento o engañoso; o</li>
            <li>
              Infringe de cualquier otro modo estos Términos o las Políticas
              Operativas.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          La Empresa no está obligada a revisar de forma previa todo el
          Contenido de los Miembros.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 11. Restricciones y conductas prohibidas
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los Miembros no podrán realizar ninguna de las siguientes actividades:
          <PolicyHyphenList>
            <li>
              Proporcionar información falsa o utilizar indebidamente la Cuenta
              o identidad de otra persona;
            </li>
            <li>
              Copiar, modificar, distribuir, vender, transferir, prestar,
              realizar ingeniería inversa, descompilar o intentar extraer el
              código fuente de los Servicios sin autorización, salvo cuando la
              legislación aplicable lo permita expresamente;
            </li>
            <li>
              Difamar, amenazar, acosar o perjudicar de cualquier otra forma a
              otra persona;
            </li>
            <li>
              Publicar materiales ilegales, obscenos, de carácter explotador o
              de otro modo prohibidos;
            </li>
            <li>
              Infringir derechos de autor, marcas, derechos de privacidad u
              otros derechos de la Empresa o de terceros;
            </li>
            <li>
              Publicar información falsa o engañosa relativa a la Empresa o a
              otras personas;
            </li>
            <li>
              Distribuir Contenido contrario a la legislación aplicable o al
              orden público;
            </li>
            <li>
              Introducir malware, virus, código malicioso u otros elementos
              destinados a dañar o interrumpir los Servicios;
            </li>
            <li>
              Interferir intencionadamente o interrumpir el funcionamiento
              normal de los Servicios;
            </li>
            <li>
              Suplantar a otra persona o declarar falsamente una relación con
              una persona u organización;
            </li>
            <li>
              Recopilar, almacenar o divulgar públicamente Datos Personales de
              otro Miembro sin autorización legítima;
            </li>
            <li>
              Difundir información fraudulenta para obtener un beneficio
              económico o causar daños;
            </li>
            <li>
              Participar en juegos de azar ilegales u otras actividades
              ilícitas;
            </li>
            <li>
              Solicitar o facilitar servicios sexuales ilegales o conductas de
              explotación;
            </li>
            <li>
              Enviar repetidamente Contenido destinado a causar miedo,
              humillación, acoso o angustia significativa;
            </li>
            <li>
              Transmitir o publicar información prohibida por la legislación
              aplicable;
            </li>
            <li>
              Suplantar al personal de la Empresa, administradores de los
              Servicios o socios comerciales;
            </li>
            <li>
              Abusar de los sistemas de denuncia mediante denuncias falsas o
              maliciosas;
            </li>
            <li>
              Acosar, perseguir o realizar otras conductas abusivas que
              interfieran con el uso de los Servicios por parte de otro Miembro;
              o
            </li>
            <li>
              Infringir de cualquier otra forma la legislación aplicable, estos
              Términos o las Políticas Operativas.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          El acceso a determinados Servicios podrá restringirse en función de la
          edad, elegibilidad, jurisdicción u otros requisitos legales.
        </li>
        <li>
          Si un Miembro infringe este Artículo, la Empresa podrá investigar la
          conducta y eliminar Contenido, restringir temporal o permanentemente
          determinadas funciones, suspender la Cuenta o terminar la relación
          contractual de uso de los Servicios.
        </li>
        <li>
          La Empresa podrá adoptar inmediatamente medidas más estrictas en casos
          de conductas ilícitas graves, daños importantes a otras personas,
          amenazas para la seguridad, riesgos de seguridad o infracciones
          reiteradas.
        </li>
        <li>
          Los Miembros podrán ponerse en contacto con Atención al Cliente para
          solicitar una revisión de las restricciones impuestas por la Empresa.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 12. Terminación de la relación de uso de los Servicios
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Cuando un Miembro elimine su Cuenta, finalizará también la relación
          contractual de uso de los Servicios entre el Miembro y la Empresa.
        </li>
        <li>
          El Miembro podrá solicitar la eliminación de su Cuenta en cualquier
          momento mediante la función correspondiente de los Servicios o
          poniéndose en contacto con Atención al Cliente.
        </li>
        <li>
          Tras la terminación, la información del Miembro y los datos de los
          Servicios serán tratados de conformidad con la legislación aplicable y
          la <strong>Política de Privacidad de pregnancy&amp;baby</strong>.
        </li>
        <li>
          Los Datos Personales que permitan identificar al Miembro serán
          eliminados de acuerdo con la Política de Privacidad, salvo cuando su
          conservación sea exigida o permitida por la legislación aplicable.
        </li>
        <li>
          Determinados datos del Servicio podrán ser anonimizados de forma
          irreversible y conservarse para fines de investigación, estadística,
          análisis y mejora del servicio, según se describe en la Política de
          Privacidad.
        </li>
        <li>
          El Contenido compartido públicamente o con otros Miembros, incluidas
          publicaciones y comentarios en la comunidad, puede no eliminarse
          automáticamente cuando se elimine la Cuenta si forma parte de
          conversaciones, interacciones o espacios compartidos de otros
          Miembros.
        </li>
        <li>
          Se recomienda a los Miembros eliminar antes de la eliminación de su
          Cuenta cualquier Contenido que deseen retirar. Si permanece Contenido
          después de la eliminación de la Cuenta, la Información de la Cuenta
          que pueda identificar al Miembro, como el nombre de usuario o apodo,
          podrá eliminarse o desvincularse, según corresponda.
        </li>
        <li>
          Si un Miembro utiliza un proveedor de inicio de sesión externo como
          Google, Apple y elimina o desconecta dicha cuenta externa, es posible
          que ya no pueda acceder a pregnancy&amp;baby mediante ese método de
          inicio de sesión.
        </li>
        <li>
          Los datos eliminados como consecuencia de la eliminación de la Cuenta,
          por regla general, no podrán recuperarse.
        </li>
        <li>
          Un antiguo Miembro podrá solicitar la creación de una nueva Cuenta,
          salvo que el nuevo registro esté restringido debido a infracciones
          anteriores de la legislación aplicable, estos Términos o las Políticas
          Operativas.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 13. Protección de Datos Personales
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          La Empresa tratará Datos Personales en la medida necesaria para
          prestar los Servicios y de conformidad con la normativa aplicable
          sobre privacidad y protección de datos.
        </li>
        <li>
          Los Datos Personales se tratarán únicamente para las finalidades y
          dentro del alcance descritos en la Política de Privacidad de la
          Empresa, los avisos de consentimiento correspondientes y demás
          comunicaciones exigidas legalmente.
        </li>
        <li>
          Cuando una función requiera el tratamiento de información de salud u
          otros Datos Personales sensibles, la Empresa obtendrá el
          consentimiento exigido por la legislación aplicable.
        </li>
        <li>
          La Empresa no comunicará Datos Personales a terceros independientes
          salvo:
          <PolicyHyphenList>
            <li>Con el consentimiento del Miembro;</li>
            <li>En los casos descritos en la Política de Privacidad;</li>
            <li>A proveedores que traten datos por cuenta de la Empresa;</li>
            <li>Cuando la legislación lo exija o permita; o</li>
            <li>En otras circunstancias legalmente permitidas.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Puede encontrarse información más detallada sobre la recopilación,
          uso, comunicación, conservación, transferencia internacional y
          protección de Datos Personales en la{" "}
          <strong>Política de Privacidad de pregnancy&amp;baby</strong>.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>Capítulo 4. Servicios de Pago</PolicySectionTitle>
      <PolicyArticleTitle>
        Artículo 14. Información sobre los Servicios de Pago
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Si la Empresa ofrece Servicios de Pago, los Miembros podrán acceder a
          ellos mediante el pago de una <strong>tarifa única</strong> conforme a
          las condiciones indicadas para el Servicio de Pago correspondiente.
        </li>
        <li>
          Antes de finalizar la compra, la Empresa o la tienda de aplicaciones
          correspondiente facilitará razonablemente información esencial como:
          <PolicyHyphenList>
            <li>Nombre o descripción del Servicio de Pago;</li>
            <li>Proveedor del Servicio de Pago;</li>
            <li>Contenido y funciones principales del Servicio de Pago;</li>
            <li>Precio aplicable; y</li>
            <li>
              Otras condiciones relevantes de compra exigidas por la legislación
              aplicable.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          La disponibilidad de los Servicios de Pago puede depender del
          dispositivo, sistema operativo, país, tienda de aplicaciones y otros
          requisitos técnicos de la persona usuaria.
        </li>
        <li>
          Salvo que se indique expresamente lo contrario, los Servicios de Pago
          son{" "}
          <strong>
            compras únicas, no se renuevan automáticamente y no generan cargos
            recurrentes
          </strong>
          .
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 15. Formalización del contrato de Servicio de Pago
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los Miembros podrán adquirir un Servicio de Pago mediante el
          procedimiento de compra puesto a disposición por la Empresa o la
          tienda de aplicaciones correspondiente.
        </li>
        <li>
          El proceso de compra puede incluir:
          <PolicyHyphenList>
            <li>Revisión y selección del Servicio de Pago;</li>
            <li>Revisión del precio y de las condiciones relevantes;</li>
            <li>Selección de un método de pago disponible;</li>
            <li>Confirmación de la compra; y</li>
            <li>Finalización del pago.</li>
          </PolicyHyphenList>
        </li>
        <li>
          El contrato relativo al Servicio de Pago se formalizará cuando la
          compra se complete correctamente y se muestre o facilite una
          confirmación.
        </li>
        <li>
          La Empresa podrá rechazar, cancelar o suspender una transacción si:
          <PolicyHyphenList>
            <li>Se utiliza información falsa o no autorizada;</li>
            <li>El método de pago no está válidamente autorizado;</li>
            <li>
              El Miembro no tiene capacidad legal para realizar la transacción;
            </li>
            <li>
              Existen problemas técnicos u operativos que impiden completar la
              compra;
            </li>
            <li>La Cuenta del Miembro está suspendida o restringida; o</li>
            <li>
              La transacción infringe la legislación aplicable, estos Términos o
              las políticas de la tienda correspondiente.
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 16. Pago de los Servicios de Pago
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los métodos de pago disponibles pueden variar según el país,
          dispositivo, plataforma y los métodos admitidos por la tienda de
          aplicaciones o proveedor de pagos correspondiente.
        </li>
        <li>
          Cuando un Servicio de Pago se adquiera mediante una aplicación móvil,
          el pago podrá procesarse como una{" "}
          <strong>
            compra única dentro de la aplicación (one-time in-app purchase)
          </strong>{" "}
          a través de:
          <PolicyHyphenList>
            <li>Apple App Store</li>
            <li>Google Play</li>
          </PolicyHyphenList>
        </li>
        <li>
          Los pagos realizados a través de una tienda de aplicaciones estarán
          sujetos a sus condiciones de pago, normas de facturación,
          procedimientos de cancelación, políticas de reembolso y demás
          políticas aplicables.
        </li>
        <li>
          Los Miembros únicamente podrán utilizar métodos de pago que estén
          legalmente autorizados a utilizar.
        </li>
        <li>
          Los Miembros son responsables de garantizar que la información
          facilitada en relación con el pago sea exacta y esté debidamente
          autorizada.
        </li>
        <li>
          Los proveedores de pago o las tiendas de aplicaciones pueden
          establecer límites de transacción, restricciones regionales,
          requisitos de edad u otras condiciones.
        </li>
        <li>
          La Empresa no almacena los datos completos de tarjetas de pago cuando
          el pago sea procesado íntegramente por una tienda de aplicaciones o un
          proveedor de pagos independiente.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 17. Cancelación y desistimiento de los Servicios de Pago
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          El derecho del Miembro a cancelar una compra, ejercer un derecho de
          desistimiento u obtener un reembolso respecto de un Servicio de Pago
          se determinará teniendo en cuenta:
          <PolicyHyphenList>
            <li>La legislación aplicable de protección de consumidores;</li>
            <li>La naturaleza del Servicio de Pago;</li>
            <li>Si el Servicio de Pago ya ha sido prestado o utilizado;</li>
            <li>Las condiciones comunicadas en el momento de la compra; y</li>
            <li>
              Cuando la compra se haya realizado a través de una tienda de
              aplicaciones, las políticas de dicha tienda.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          En las compras realizadas mediante Apple App Store o Google Play, las
          solicitudes de cancelación, desistimiento o reembolso pueden tener que
          presentarse directamente a través de la tienda correspondiente
          conforme a sus políticas.
        </li>
        <li>
          Determinados contenidos o servicios digitales pueden quedar excluidos
          del derecho de desistimiento o reembolso una vez iniciada su
          prestación o utilización cuando la legislación aplicable lo permita y
          se hayan proporcionado los avisos u obtenido los consentimientos
          legalmente exigidos.
        </li>
        <li>
          Ninguna disposición de estos Términos limita los derechos obligatorios
          de cancelación, desistimiento o reembolso que correspondan al Miembro
          conforme a la legislación aplicable.
        </li>
        <li>
          Las ventajas, cupones u otros beneficios adicionales proporcionados en
          relación con una compra posteriormente reembolsada podrán retirarse o
          restringirse en la medida permitida por la legislación aplicable.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 18. Restricción del uso de los Servicios de Pago
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          La Empresa pondrá a disposición del Miembro un Servicio de Pago
          adquirido válidamente de conformidad con las condiciones comunicadas
          para dicho servicio.
        </li>
        <li>
          La Empresa podrá restringir o suspender el acceso a un Servicio de
          Pago, en la medida permitida por la legislación aplicable, cuando el
          Miembro:
          <PolicyHyphenList>
            <li>Infrinja estos Términos;</li>
            <li>Realice actividades fraudulentas o ilícitas;</li>
            <li>Utilice un método de pago sin autorización;</li>
            <li>Abuse de los sistemas de pago o reembolso; o</li>
            <li>
              Realice cualquier otra conducta que proporcione una base razonable
              para imponer una restricción conforme a la legislación aplicable.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Cuando proceda, el Miembro podrá ponerse en contacto con Atención al
          Cliente para solicitar la revisión de dicha restricción.
        </li>
        <li>
          Una restricción de uso de un Servicio de Pago no implica, salvo que se
          indique expresamente lo contrario, la terminación de la Cuenta
          pregnancy&amp;baby del Miembro.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Artículo 19. Reembolsos</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          El derecho a obtener un reembolso y el importe correspondiente
          dependerán de la legislación aplicable, del tipo de Servicio de Pago,
          de si el servicio o contenido digital ya ha sido prestado o utilizado
          y de las políticas comunicadas en el momento de la compra.
        </li>
        <li>
          Cuando una compra haya sido procesada mediante{" "}
          <strong>Apple App Store o Google Play</strong>, se aplicarán, con
          carácter general, las políticas y procedimientos de reembolso de la
          tienda correspondiente y la Empresa puede no estar facultada para
          efectuar directamente el reembolso.
        </li>
        <li>
          Determinados contenidos o servicios digitales pueden no ser
          reembolsables una vez iniciada su prestación o utilización cuando la
          legislación aplicable lo permita y se hayan proporcionado los avisos u
          obtenido los consentimientos legalmente exigidos.
        </li>
        <li>
          Si un determinado Servicio de Pago está sujeto a una política de
          reembolso específica, la Empresa la facilitará durante el proceso de
          compra.
        </li>
        <li>
          Ninguna disposición de este Artículo excluye o limita los derechos de
          reembolso, cancelación, desistimiento u otros derechos del consumidor
          que no puedan ser legalmente excluidos o limitados conforme a la
          legislación aplicable al Miembro.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>Capítulo 5. Otras disposiciones</PolicySectionTitle>
      <PolicyArticleTitle>
        Artículo 20. Exclusión de garantías y responsabilidad
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          En la medida máxima permitida por la legislación aplicable, la Empresa
          no ofrece garantías respecto de cuestiones no establecidas
          expresamente en estos Términos.
        </li>
        <li>
          La Empresa no garantiza la integridad, exactitud, fiabilidad o
          idoneidad para una finalidad concreta de la información proporcionada
          por:
          <PolicyHyphenList>
            <li>Miembros;</li>
            <li>Proveedores externos de contenido;</li>
            <li>Bases de datos públicas;</li>
            <li>Servicios externos; u</li>
            <li>Otras fuentes independientes.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Los Servicios, incluidas las predicciones del ciclo menstrual,
          estimaciones del período fértil, cálculos relacionados con el
          embarazo, análisis del crecimiento fetal, información sobre
          crecimiento y desarrollo infantil y otras funciones relacionadas con
          la salud, se proporcionan con{" "}
          <strong>fines informativos y de apoyo a las personas usuarias</strong>
          .
        </li>
        <li>
          Los Servicios no constituyen ni pretenden sustituir un diagnóstico,
          examen, tratamiento o asesoramiento médico profesional.
        </li>
        <li>
          Cuando los daños se produzcan como consecuencia de una conducta dolosa
          o negligente de la Empresa, esta responderá de conformidad con la
          legislación aplicable.
        </li>
        <li>
          En la medida permitida por la legislación aplicable, la Empresa no
          será responsable de daños que no hayan sido causados por su dolo o
          negligencia, incluidos los que deriven exclusivamente de:
          <PolicyHyphenList>
            <li>
              Fuerza mayor o circunstancias fuera del control razonable de la
              Empresa;
            </li>
            <li>Acciones u omisiones del propio Miembro;</li>
            <li>
              Accesos no autorizados o ataques de terceros que razonablemente no
              pudieran haberse evitado;
            </li>
            <li>Malware o software malicioso introducido por terceros;</li>
            <li>
              Fallos de redes, sistemas o servicios de terceros fuera del
              control razonable de la Empresa; o
            </li>
            <li>
              Otras circunstancias no causadas por dolo o negligencia de la
              Empresa.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          En la medida permitida por la legislación aplicable, la Empresa no
          será responsable de controversias que surjan exclusivamente entre
          Miembros o entre un Miembro y un tercero independiente, salvo cuando
          la Empresa sea legalmente responsable de la cuestión.
        </li>
        <li>
          Ninguna disposición de estos Términos excluye o limita
          responsabilidades que no puedan excluirse o limitarse legalmente
          conforme a la normativa de protección de consumidores u otras
          disposiciones imperativas.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 21. Notificaciones y comunicaciones
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los Miembros podrán ponerse en contacto con la Empresa en cualquier
          momento a través de Atención al Cliente para cuestiones relacionadas
          con los Servicios.
        </li>
        <li>
          Los avisos generales dirigidos a todos los Miembros podrán publicarse
          dentro de los Servicios durante al menos siete (7) días o comunicarse
          mediante otro método razonable.
        </li>
        <li>
          Las cuestiones que afecten de forma material a los derechos de un
          Miembro o al uso de los Servicios podrán comunicarse individualmente
          mediante:
          <PolicyHyphenList>
            <li>Correo electrónico;</li>
            <li>Notificación push;</li>
            <li>Mensaje dentro de la aplicación; u</li>
            <li>Otro medio electrónico adecuado.</li>
          </PolicyHyphenList>
        </li>
        <li>
          La Empresa no estará obligada a utilizar un medio de comunicación
          respecto del cual el Miembro no haya facilitado la información
          necesaria para recibir la comunicación.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 22. Ley aplicable y resolución de conflictos
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Los presentes Términos y la relación entre la Empresa y los Miembros
          se regirán, con carácter general, por las leyes de la{" "}
          <strong>República de Corea</strong>, sin perjuicio de las
          disposiciones imperativas de protección de consumidores u otros
          derechos obligatorios aplicables conforme a las leyes del país o
          región de residencia del Miembro.
        </li>
        <li>
          Si surge una controversia relacionada con los Servicios, la Empresa y
          el Miembro realizarán primero esfuerzos razonables para resolverla
          mediante negociación de buena fe.
        </li>
        <li>
          Si la controversia no puede resolverse de forma amistosa, podrá
          someterse a un tribunal competente de conformidad con la legislación
          aplicable.
        </li>
        <li>
          Ninguna disposición de estos Términos priva al Miembro de su derecho a
          presentar una reclamación ante un tribunal o autoridad competente
          cuando dicho derecho esté garantizado por normas imperativas del país
          o región en el que reside.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Artículo 23. Disposiciones generales
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Las cuestiones no previstas expresamente en estos Términos se regirán
          por la legislación aplicable y, cuando sea permitido, por las
          prácticas generalmente aceptadas.
        </li>
        <li>
          Si alguna disposición de estos Términos se considera inválida, ilegal
          o inaplicable, las restantes disposiciones continuarán en vigor en la
          máxima medida permitida por la legislación.
        </li>
        <li>
          El hecho de que la Empresa no exija el cumplimiento de una disposición
          de estos Términos no constituirá una renuncia a dicha disposición ni a
          ningún otro derecho.
        </li>
        <li>
          Los títulos utilizados en estos Términos se incluyen únicamente por
          comodidad y no afectan a su interpretación.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Disposición adicional</PolicyArticleTitle>
      <PolicyText>
        Los presentes Términos entrarán en vigor el{" "}
        <strong>[21 de septiembre de 2026]</strong>.
      </PolicyText>
      <PolicyText>
        Para los Miembros que se registren después de la publicación de estos
        Términos pero antes de la Fecha de entrada en vigor indicada, la Empresa
        podrá aplicar estos Términos desde la fecha de registro en la medida
        permitida por la legislación aplicable.
      </PolicyText>
    </PolicyContainer>
  );
};

export default ServiceEs;
